export default "__VITE_ASSET__7Ko5XJzy__"